/**
 * 老师查询添加教参
 * 谢冉
 * 2020.8.25
 */
import '@instructure/canvas-theme';
import { Alert } from '@instructure/ui-alerts';
import { CondensedButton } from '@instructure/ui-buttons';
import { Button } from '@instructure/ui-buttons/es/Button';
import { Checkbox } from '@instructure/ui-checkbox';
import { FormField, FormFieldGroup } from '@instructure/ui-form-field';
import { Link } from '@instructure/ui-link';
import { Modal } from '@instructure/ui-modal';
import { Table } from '@instructure/ui-table';
import { Pagination } from '@instructure/ui-pagination';
import { View } from '@instructure/ui-view';
import { Tooltip } from '@instructure/ui-tooltip';
import { IconEditLine } from '@instructure/ui-icons'
import React, { useEffect, useState } from 'react';
import { instance } from '../axios';
import imgURL from '../images/c1-empt.svg';
import { search2query, setToken } from '../utils/store';
import EmailInfo from './EmailInfo';
import Recommend from './Recommend';
import EditInput from './EditInput';
import courseConfig from '../utils/courseConfig';
import '../css/styles.css';

function GuideBooks(props) {
  const [alertToggle, setAlertToggle] = useState('none');
  const [alerts, setAlerts] = useState([]);
  const [rows, setRows] = useState([]);
  const [rowsIds, setRowsIds] = useState([]);

  const [open, setOpen] = useState(false);
  const [openUrlModal, setOpenUrlModal] = useState(false);
  const [urlList, setUrlList] = useState([]);
  const [currentRating, setCurrentRating] = useState(null);
  const [message, setMessage] = useState('');
  const [ghId, setGhId] = useState();
  const [openDetail, setOpenDetail] = useState(false);
  const [openExtend, setOpenExtend] = useState(false);
  const [address, setAddress] = useState(false);
  const [extendList, setExtendList] = useState([]);
  const [selected, setSelected] = useState([]);
  const [rowIds, setRowIds] = useState([]);
  const [isRender, setIsRender] = useState(true);
  const [sortConfig, setSortConfig] = useState({ key: 'cbrq', direction: 'ascending' });
  const [page, setPage] = useState(0);
  const [hisRows, setHisRows] = useState([]);
  
  const currentCourseConfig = courseConfig[props?.kcdm || ''];

  // 推荐model
  const [showRecommend, setShowRecommend] = useState(false);

  const allSelected =
    selected.length > 0 && rowIds.every(id => selected.includes(id));
  const someSelected = selected.length > 0 && !allSelected;
  const [objInfo, setObjInfo] = useState({
    jcmc: '', // 书名
    type: '', //类型
    isbn: '', // isbn
    zzxm: '', // 作者姓名
    cbdw: '', // 出版单位
    cbrq: '', // 出版日期
    callno: '', // 索书号
    language: '', // 语种
    internalId: '',
    jcId: '', // 教参id
    bsId: '', // 课程id
    userId: '', // 用户id
    isTeacher: '', // 是否为老师
  });

  const getInitToken = () => {
    const paramsObj = search2query(props.location.search);
    if (paramsObj?.code) {
      instance({
        method: 'get',
        url: `oauth/getToken`,
        params: {
          code: paramsObj?.code,
        },
      }).then(res => {
        const { code, data, message: msg } = res?.data;
        switch (code) {
          case 0:
            console.log('获取的token', data);
            setToken(data);
            // 把code删掉 重新跳转
            let urlParams = window.location.href;
            let lastIndex = urlParams.lastIndexOf('&');
            let result = urlParams.substring(0, lastIndex);
            setTimeout(() => {
              window.location.href = result;
              window.location.reload();
            }, 0);
            break;
          default:
            console.log(msg);
            break;
        }
      });
      return;
    } else {
      fetchData();
    }
  };

  const getURLParams = () => {
    const paramsObj = search2query(props.location.search);
    if (
      paramsObj?.courseId &&
      paramsObj?.ghId &&
      paramsObj?.isTeacher &&
      paramsObj?.userId
    ) {
      console.log('222222s');
      localStorage.setItem('urlParams', JSON.stringify(paramsObj));
      setIsRender(true);
    } else {
      setIsRender(false);
      console.log('url参数不全', paramsObj);
      return;
    }
  };

  const fetchData = async () => {
    const paramsObj = search2query(props.location.search);

    getURLParams();

    setObjInfo({
      jcmc: '', // 书名
      type: '', //类型
      isbn: '', // isbn
      zzxm: '', // 作者姓名
      cbdw: '', // 出版单位
      cbrq: '', // 出版日期
      callno: '', // 索书号
      language: '', // 语种
      internalId: '',
      jcId: '', // 教参id
      bsId: paramsObj.courseId, // 课程id
      userId: paramsObj.userId, // 用户id
      isTeacher: paramsObj.isTeacher, // 是否为老师
    });
    setGhId(paramsObj.ghId);
    let bsid = paramsObj.courseId;
    if (bsid) {
      await instance({
        method: 'get',
        url: `searchReferenceByKcId/${bsid}`,
      })
        .then(res => {
          console.log(res.headers['redirect']);
          if (res.data.code && res.data.code === 400 && res.data.message) {
            setObjInfo({
              jcmc: '', // 书名
              type: '', //类型
              isbn: '', // isbn
              zzxm: '', // 作者姓名
              cbdw: '', // 出版单位
              cbrq: '', // 出版日期
              callno: '', // 索书号
              language: '', // 语种
              internalId: '',
              jcId: '', // 教参id
              bsId: paramsObj.courseId, // 课程id
              userId: paramsObj.userId, // 用户id
              isTeacher: false, // 是否为老师
            });
            setMessage(res.data.message);
          }
          if (res.data.data) {
            setAddress(true);
            const responseData = res.data.data;
            const rowsArr = [];
            responseData.map((item, index) => {
              rowsArr.push(
                Object.assign(item, { number: index + 1 })
              );
              return item.id;
            });
            setRows(rowsArr);
            setRowsIds(rowsArr.map(i => i.id));
          }
        })
        .catch(() => {})
        .finally(() => {});
    }
  };

  useEffect(() => {
    getURLParams();

    getInitToken();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.location.search]);

  //  添加新教参
  const onAddNewReference = () => {
    let obj = objInfo;
    sessionStorage.setItem('info', JSON.stringify(obj));
    props.history.push(
      `/searchData?userId=` +
        objInfo.userId +
        `&courseId=` +
        objInfo.bsId +
        `&isTeacher=` +
        objInfo.isTeacher+
        `&ghId=` +
        ghId
    );
  };
  // 查看全文
  const handleReadMoreClick = (rating) => {
    if (rating.referenceUrl) {
      const urls = rating.referenceUrl.split(';').filter(url => url);
      setUrlList(urls);
      setCurrentRating(rating);
      setOpenUrlModal(true);
    }
  };
  const onReadMore = async rating => {
    instance({
      method: 'post',
      url: `addVisitLog`,
      data: {
        referenceInternalId: rating?.internalId,
        userId: objInfo.userId,
      },
    }).then(({ data }) => {
      console.log(data);
    });
    if (ghId && ghId !== '' && rating.id && rating.id !== '') {
      instance({
        method: 'get',
        url: `addLog?ghId=${ghId}&jcId=${rating.id}&bsid=${objInfo.bsId}`,
      })
        .then(res => {
          console.log('查看全文返回结果', res);
        })
        .catch(error => {
          console.log('全文错误', error);
        });
    }
  };

  // 编辑
  const onEdit = rating => {
    let obj = {
      jcmc: rating.jcmc, // 书名
      type: rating.type, //类型
      isbn: rating.isbn, // isbn
      zzxm: rating.zzxm, // 作者姓名
      cbdw: rating.cbdw, // 出版单位
      cbrq: rating.cbrq, // 出版日期
      callno: rating.callno, // 索书号
      language: rating.language, // 语种
      internalId: rating.internalId,
      jcId: rating.id, // 教参id
      bsId: objInfo.bsId, // 课程id
      userId: objInfo.userId, // 用户id
      isTeacher: objInfo.isTeacher, // 是否为老师
    };
    sessionStorage.setItem('info', JSON.stringify(obj));
  };

  // 打开确认删除弹框
  const onOpen = rating => {
    setOpen(true);
    setObjInfo({
      jcmc: objInfo.jcmc, // 书名
      type: objInfo.type, //类型
      isbn: objInfo.isbn, // isbn
      zzxm: objInfo.zzxm, // 作者姓名
      cbdw: objInfo.cbdw, // 出版单位
      cbrq: objInfo.cbrq, // 出版日期
      callno: objInfo.callno, // 索书号
      language: objInfo.language, // 语种
      internalId: objInfo.internalId,
      jcId: rating.id, // 教参id
      bsId: objInfo.bsId, // 课程id
      userId: objInfo.userId, // 用户id
      isTeacher: objInfo.isTeacher, // 是否为老师
    });
  };

  // 取消关闭删除弹框
  const onClose = () => {
    setOpen(false);
    setObjInfo({
      jcmc: objInfo.jcmc, // 书名
      type: objInfo.type, //类型
      isbn: objInfo.isbn, // isbn
      zzxm: objInfo.zzxm, // 作者姓名
      cbdw: objInfo.cbdw, // 出版单位
      cbrq: objInfo.cbrq, // 出版日期
      callno: objInfo.callno, // 索书号
      language: objInfo.language, // 语种
      internalId: objInfo.internalId,
      jcId: '', // 教参id
      bsId: objInfo.bsId, // 课程id
      userId: objInfo.userId, // 用户id
      isTeacher: objInfo.isTeacher, // 是否为老师
    });
  };

  // 确定删除并关闭弹框
  const onDelete = () => {
    setOpen(false);
    let parameter = {
      jcid: objInfo.jcId,
      bsid: objInfo.bsId,
      status: 'disable',
    };
    const variants = ['success', 'error'];
    const politeness = ['删除成功', '删除失败'];
    const alert = [];
    instance({
      method: 'post',
      url: `updateKcJcRelation`,
      data: parameter,
    })
      .then(res => {
        if (res && res.data && res.data.message === 'SUCCESS') {
          //  删除成功后又查询一次以确保排序正确
          instance({
            method: 'get',
            url: `searchReferenceByKcId/${objInfo.bsId}`,
          })
            .then(res => {
              const responseData = res.data.data;
              const rowsArr = [];
              responseData.map((item, index) => {
                rowsArr.push(
                  Object.assign(item, { number: index + 1 })
                );
                return item.id;
              });
              setRows(rowsArr);
              setRowsIds(rowsArr.map(i => i.id));
            })
            .catch(() => {});
          alert['politenessName'] = politeness[0];
          alert['variants'] = variants[0];
          setAlerts(alert);
          setAlertToggle('block');
          setTimeout(() => {
            setAlertToggle('none');
            setAlerts([]);
          }, 3000);
        }
      })
      .catch(() => {});
  };

  // 详情
  const onDetail = rating => {
    setObjInfo({
      jcmc: rating.jcmc, // 书名
      type: objInfo.type, //类型
      isbn: rating.isbn, // isbn
      zzxm: rating.zzxm, // 作者姓名
      cbdw: rating.cbdw, // 出版单位
      cbrq: rating.cbrq, // 出版日期
      callno: rating.callno, // 索书号
      language: rating.language, // 语种
      internalId: objInfo.internalId,
      jcId: objInfo.jcId, // 教参id
      bsId: objInfo.bsId, // 课程id
      userId: objInfo.userId, // 用户id
      isTeacher: objInfo.isTeacher, // 是否为老师
      csx: rating.csx, // 丛书项
      ys: rating.ys, // 页数
      bb: rating.bb, // 版本
    });
    setOpenDetail(true);
  };

  //  关闭详情弹框
  const onCloseDetail = () => {
    setOpenDetail(false);
  };
  //  表格按钮
  const renderCondensedButton = rating => (
    <p style={{ display: 'flex', justifyContent: ' space-evenly' }}>
      {rating && rating.urlupdateflg === 2 ? (
        <CondensedButton onClick={() => handleReadMoreClick(rating)}>
          查看全文
        </CondensedButton>
      ) : (
        <CondensedButton interaction="disabled">查看全文</CondensedButton>
      )}
      {objInfo.isTeacher && objInfo.isTeacher === 'true' ? (
        rating && rating.status === 1 && rating.modifyflg === 0 ? (
          <Link href="#/addForm">
            <CondensedButton onClick={() => onEdit(rating)}>
              编辑
            </CondensedButton>
          </Link>
        ) : (
          <CondensedButton
            interaction="disabled"
            onClick={() => onEdit(rating)}
          >
            编辑
          </CondensedButton>
        )
      ) : (
        ''
      )}
      <CondensedButton onClick={() => onDetail(rating)}>详情</CondensedButton>
      {objInfo.isTeacher && objInfo.isTeacher === 'true' ? (
        <CondensedButton onClick={() => onOpen(rating)}>删除</CondensedButton>
      ) : (
        ''
      )}
    </p>
  );

  const headers = [
    {
      id: 'number',
      text: '序号',
      width: '5%',
      textAlign: 'center',
    },
    {
      id: 'orderNum',
      text: <>保障顺序<IconEditLine style={{ marginLeft: '10px' }} /></>,
      width: '5%',
      textAlign: 'start',
      isHidden: !objInfo?.isTeacher || objInfo?.isTeacher !== 'true',
      renderCell: rating => (
        <EditInput
          key={`EditInput_${rating?.id}`}
          orderNum={rating?.orderNum || 0}
          onSubmit={
            orderNum => {
              let parameter = {
                ...rating,
                orderNum,
              };
              const variants = ['success', 'error'];
              const politeness = ['修改成功', '修改失败'];
              const alert = [];
              instance({
                method: 'post',
                url: `updateReference`,
                data: parameter,
              })
                .then(res => {
                  if (res && res.data && res.data.id) {
                    //  修改成功后又查询一次以确保排序正确
                    fetchData();
                    alert['politenessName'] = politeness[0];
                    alert['variants'] = variants[0];
                    setAlerts(alert);
                    setAlertToggle('block');
                    setTimeout(() => {
                      setAlertToggle('none');
                      setAlerts([]);
                    }, 3000);
                  }
                })
                .catch(() => {});
            }
          }
        />
      ),
    },
    {
      id: 'jcmc',
      text: '名称',
      width: '18%',
      textAlign: 'start',
    },
    {
      id: 'zzxm',
      text: '作者',
      width: '15%',
      textAlign: 'start',
    },
    {
      id: 'language',
      text: '语种',
      width: '7%',
      textAlign: 'start',
      renderCell: data => {
        const language = data.language;
        if (language === '01' || language === 'chi') {
          return '中文';
        } else if (language === '09') {
          return '外文';
        }
        return language;
      },
    },
    {
      id: 'cbdw',
      text: '出版社',
      width: '10%',
      textAlign: 'start',
    },
    {
      id: 'isbn',
      text: 'ISBN',
      width: '10%',
      textAlign: 'start',
    },
    {
      id: 'cbrq',
      text: '出版年',
      width: '10%',
      textAlign: 'start',
      sortable: true,
    },
    // {
    //   id: 'urlupdateflg',
    //   text: '是否有电子版',
    //   width: '5%',
    //   textAlign: 'start',
    //   renderCell: rating => rating?.urlupdateflg === 2 ? '是' : '否',
    // },
    {
      id: 'action',
      text: '操作',
      width: '20%',
      textAlign: 'center',
      renderCell: rating => renderCondensedButton(rating),
    },
  ];
  const headers2 = [
    {
      id: 'resource',
      text: '类型',
      width: '10%',
      textAlign: 'start',
    },
    {
      id: 'jcmc',
      text: '名称',
      width: '20%',
      textAlign: 'start',
    },
    {
      id: 'zzxm',
      text: '作者',
      width: '20%',
      textAlign: 'start',
    },
    {
      id: 'cbdw',
      text: '出版社',
      width: '10%',
      textAlign: 'start',
    },
    {
      id: 'isbn',
      text: 'ISBN',
      width: '10%',
      textAlign: 'start',
    },
    {
      id: 'cbrq',
      text: '出版年',
      width: '10%',
      textAlign: 'start',
      sortable: true,
    },
    {
      id: 'creatorNum',
      text: '添加人',
      width: '10%',
      textAlign: 'start',
      sortable: true,
    },
  ];

  // 统一的排序和分页逻辑
  useEffect(() => {
    if (extendList && extendList.length > 0) {
      const sortedList = [...extendList].sort((a, b) => {
        const aValue = a[sortConfig.key];
        const bValue = b[sortConfig.key];

        if (aValue < bValue) {
          return sortConfig.direction === 'ascending' ? -1 : 1;
        }
        if (aValue > bValue) {
          return sortConfig.direction === 'ascending' ? 1 : -1;
        }
        return 0;
      });
      setHisRows(sortedList.slice(page * 10, (page + 1) * 10));
    } else {
      setHisRows([]);
    }
  }, [extendList, sortConfig, page]);


  const handleSort = (key) => {
    let direction = 'ascending';
    if (sortConfig.key === key && sortConfig.direction === 'ascending') {
      direction = 'descending';
    }
    setSortConfig({ key, direction });
  };

  const handleChangePage = (page) => {
    setPage(page);
  };

  return (
    <div>
      <div style={{ minHeight: 'calc(100% - 40px)' }}>
        {isRender && (
          <>
            {objInfo.isTeacher && objInfo.isTeacher === 'true' ? (
              <p style={{ display: 'flex', justifyContent: 'space-between' }}>
              <span>
                <Button
                    color="primary"
                    margin="small"
                    onClick={() => {
                      console.log(objInfo.bsId);
                      instance({
                        method: 'post',
                        url: `searchSimilarKcReferenceByKcId`,
                        data: {
                          bsId: objInfo.bsId,
                          resource: '图书',
                        },
                      }).then(response => {
                        const arr = response?.data?.data?.map((i, index) => ({
                          ...i,
                          number: index + 1,
                        }));
                        setOpenExtend(true);
                        setExtendList(arr);
                        setRowIds(
                          response?.data?.data
                            ?.map(i => i.id)
                            .filter(i => !rowsIds.includes(i))
                        );
                        // setAscending(true);
                        // setHisRows(arr.slice(page * 10, (page + 1) * 10).sort(compareYearAscDate));
                        console.log(response);
                      });
                    }}
                  >
                    +导入历史教参
                  </Button>
                  <Tooltip
                    renderTip="图书馆已有的这些电子教参可能与您的课程相关"
                    offsetY="10"
                    placement="bottom"
                  >
                    <Button
                      color="primary"
                      margin="small"
                      onClick={() => {
                        setShowRecommend(true);
                      }}
                    >
                      图书馆推荐的教参
                    </Button>
                  </Tooltip>
                  <Button
                    color="primary"
                    margin="small"
                    interaction={currentCourseConfig?.subjectAiUrl ? 'enabled' : 'disabled'}
                    onClick={() => {
                      if (currentCourseConfig?.subjectAiUrl) {
                        window.open(currentCourseConfig.subjectAiUrl, '_blank');
                      }
                    }}
                  >
                    学科AI知识库
                  </Button>
                  <Button
                    color="primary"
                    margin="small"
                    interaction={currentCourseConfig?.courseAiUrl ? 'enabled' : 'disabled'}
                    onClick={() => {
                      if (currentCourseConfig?.courseAiUrl) {
                        window.open(currentCourseConfig.courseAiUrl, '_blank');
                      }
                    }}
                  >
                    课程AI知识库
                  </Button>
                </span>
                <Button
                  color="primary"
                  margin="small"
                  onClick={() => onAddNewReference()}
                >
                  +添加新教参
                </Button>
              </p>
            ) : (
              <p>
                <Button
                  color="primary"
                  margin="small"
                  interaction={currentCourseConfig?.subjectAiUrl ? 'enabled' : 'disabled'}
                  onClick={() => {
                    if (currentCourseConfig?.subjectAiUrl) {
                      window.open(currentCourseConfig.subjectAiUrl, '_blank');
                    }
                  }}
                >
                  学科AI知识库
                </Button>
                <Button
                  color="primary"
                  margin="small"
                  interaction={currentCourseConfig?.courseAiUrl ? 'enabled' : 'disabled'}
                  onClick={() => {
                    if (currentCourseConfig?.courseAiUrl) {
                      window.open(currentCourseConfig.courseAiUrl, '_blank');
                    }
                  }}
                >
                  课程AI知识库
                </Button>
              </p>
            )}
            <div
              style={
                rows && rows.length === 0
                  ? { display: 'none' }
                  : { display: 'block', marginTop: '35px' }
              }
            >
              <Table caption="table">
                <Table.Head>
                  <Table.Row>
                    {(headers || []).map(({ id, text, width, textAlign, isHidden }) => isHidden ? '' : (
                      <Table.ColHeader
                        key={id}
                        id={id}
                        width={width}
                        textAlign={textAlign}
                      >
                        {text}
                      </Table.ColHeader>
                    ))}
                  </Table.Row>
                </Table.Head>
                <Table.Body>
                  {(rows || []).map(row => {
                    return (
                      <Table.Row>
                        {headers.map(({ id, renderCell, textAlign, isHidden }) => isHidden ? '' : (
                          <Table.Cell
                            // key={row.id}
                            id={row.id}
                            textAlign={textAlign}
                          >
                            {renderCell ? renderCell(row) : row[id]}
                          </Table.Cell>
                        ))}
                      </Table.Row>
                    );
                  })}
                </Table.Body>
              </Table>
              <Modal open={open} size="small" label="Modal Dialog: 删除教参">
                <Modal.Header>
                  <p
                    style={{
                      textAlign: 'center',
                      fontSize: '18px',
                      margin: '0px',
                      fontWeight: '700',
                    }}
                  >
                    删除教参
                  </p>
                </Modal.Header>
                <Modal.Body>
                  <p style={{ marginLeft: '2%' }}>确认删除这条教参吗？</p>
                </Modal.Body>
                <Modal.Footer>
                  <Button margin="0 x-small 0 0" onClick={() => onClose()}>
                    取消
                  </Button>
                  <Button color="primary" onClick={() => onDelete()}>
                    确定
                  </Button>
                </Modal.Footer>
              </Modal>
              <Modal
                open={openUrlModal}
                size="medium"
                label="Modal Dialog: 全文链接"
                onDismiss={() => setOpenUrlModal(false)}
              >
                <Modal.Header>
                  <p
                    style={{
                      fontSize: '18px',
                      margin: '0px',
                      fontWeight: '700',
                    }}
                  >
                    全文链接
                  </p>
                </Modal.Header>
                <Modal.Body>
                  {(urlList || []).map((url, index) => (
                    <p key={index} style={{ margin: '1rem 0', wordBreak: 'break-all' }}>
                        <Link href={url} target="_blank" rel="noopener noreferrer" onClick={() => onReadMore(currentRating)}>
                            {url}
                        </Link>
                    </p>
                  ))}
                </Modal.Body>
                <Modal.Footer>
                  <Button
                    color="primary"
                    onClick={() => setOpenUrlModal(false)}
                  >
                    关闭
                  </Button>
                </Modal.Footer>
              </Modal>
              <Modal
                open={openDetail}
                size="medium"
                label="Modal Dialog: 单册详情"
              >
                <Modal.Header>
                  <p
                    style={{
                      fontSize: '18px',
                      margin: '0px',
                      fontWeight: '700',
                    }}
                  >
                    单册详情
                  </p>
                </Modal.Header>
                <Modal.Body>
                  <div style={{ display: 'flex' }}>
                    <FormFieldGroup
                      description=""
                      layout="stacked"
                      rowSpacing="large"
                      colSpacing="none"
                    >
                      <FormField layout="inline" label="题名:">
                        {objInfo.jcmc}
                      </FormField>
                      <FormField layout="inline" label="出版单位:">
                        {objInfo.cbdw}
                      </FormField>
                      <FormField layout="inline" label="出版年:">
                        {objInfo.cbrq}
                      </FormField>
                      <FormField layout="inline" label="ISBN:">
                        {objInfo.isbn}
                      </FormField>
                      <FormField layout="inline" label="语种:">
                        {objInfo.language}
                      </FormField>
                    </FormFieldGroup>
                    <FormFieldGroup
                      description=""
                      layout="stacked"
                      rowSpacing="large"
                      colSpacing="none"
                    >
                      <FormField layout="inline" label="著者:">
                        {objInfo.zzxm}
                      </FormField>
                      <FormField layout="inline" label="丛书项:">
                        {objInfo.csx}
                      </FormField>
                      <FormField layout="inline" label="版本:">
                        {objInfo.bb}
                      </FormField>
                      <FormField layout="inline" label="索书号:">
                        {objInfo.callno}
                      </FormField>
                      <FormField layout="inline" label="页数(形态):">
                        {objInfo.ys}
                      </FormField>
                    </FormFieldGroup>
                  </div>
                </Modal.Body>
                <Modal.Footer>
                  <Button
                    color="primary"
                    onClick={rating => onCloseDetail(rating)}
                  >
                    关闭
                  </Button>
                </Modal.Footer>
              </Modal>

              <Modal
                open={openExtend}
                size="large"
                label="Modal Dialog: 导入历史教参"
              >
                <Modal.Header>
                  <p
                    style={{
                      fontSize: '18px',
                      margin: '0px',
                      fontWeight: '700',
                      display: 'flex',
                      justifyContent: 'space-between',
                    }}
                  >
                    <span>导入历史教参<span style={{ color: 'red' }}>（书籍）</span></span>
                    <Button
                      color="primary"
                      onClick={() => {
                        instance({
                          method: 'post',
                          url: `searchSimilarKcReferenceByGh`,
                          data: {
                            gh: ghId,
                            resource: '图书',
                          },
                        }).then(response => {
                          setPage(0);
                          const arr = response?.data?.data?.map((i, index) => ({
                            ...i,
                            number: index + 1,
                          }));
                          setExtendList(arr);
                          setRowIds(
                            response?.data?.data
                              ?.map(i => i.id)
                              .filter(i => !rowsIds.includes(i))
                          );
                          // setAscending(true);
                          // setHisRows(arr.slice(0, 10).sort(compareYearAscDate));
                        });
                      }}
                    >
                      查看本人所有电子教参
                    </Button>
                  </p>
                </Modal.Header>
                <Modal.Body>
                  <Table caption="table">
                    <Table.Head>
                      <Table.Row>
                        <Table.ColHeader id="select" width="10%">
                          <Checkbox
                            label=""
                            onChange={() => {
                              setSelected([
                                ...(allSelected ? new Set() : new Set(rowIds)),
                              ]);
                            }}
                            checked={allSelected}
                            indeterminate={someSelected}
                          />
                        </Table.ColHeader>
                        {(headers2 || []).map(
                          ({ id, text, width, textAlign, sortable }) => (
                            <Table.ColHeader
                              key={id}
                              id={id}
                              width={width}
                              textAlign={textAlign}
                              onRequestSort={sortable ? () => handleSort(id) : undefined}
                              sortDirection={sortConfig.key === id ? sortConfig.direction : 'none'}
                            >
                              {text}
                            </Table.ColHeader>
                          )
                        )}
                      </Table.Row>
                    </Table.Head>
                    <Table.Body>
                      {(hisRows || []).map(row => {
                        const rowSelected = selected.includes(row.id);
                        return (
                          <Table.Row key={row.id}>
                            <Table.RowHeader>
                              <Checkbox
                                label=""
                                disabled={rowsIds.includes(row.id)}
                                onChange={() => {
                                  const copy = new Set(selected);
                                  if (rowSelected) {
                                    copy.delete(row.id);
                                  } else {
                                    copy.add(row.id);
                                  }
                                  setSelected([...copy]);
                                }}
                                checked={rowSelected}
                              />
                            </Table.RowHeader>
                            {headers2.map(({ id, renderCell, textAlign }) => (
                              <Table.Cell
                                key={id}
                                id={id}
                                textAlign={textAlign}
                              >
                                {renderCell ? renderCell(row) : row[id]}
                              </Table.Cell>
                            ))}
                          </Table.Row>
                        );
                      })}
                    </Table.Body>
                  </Table>
                  {
                    !extendList?.length && <p style={{ textAlign: 'center' }}>无历史教参</p>
                  }
                  <Pagination
                    variant="compact"
                    labelNext="Next Page"
                    labelPrev="Previous Page"
                    margin="large"
                  >
                    {Array.from(Array(Math.ceil(extendList?.length / 10)), (item, index) => (
                      <Pagination.Page
                        key={index}
                        onClick={() => handleChangePage(index)}
                        current={index === page}
                      >
                        {index + 1}
                      </Pagination.Page>
                    ))}
                  </Pagination>
                </Modal.Body>
                <Modal.Footer>
                  <Button
                    color="primary"
                    margin="0 x-small 0 0"
                    interaction={selected.length ? 'enabled' : 'disabled'}
                    onClick={() => {
                      instance({
                        method: 'post',
                        url: `inheritKcReference`,
                        data: {
                          kcId: objInfo.bsId,
                          referenceIdList: selected.map(i => `${i}`),
                        },
                      }).then(res => {
                        console.log(res);
                        const variants = ['success', 'error'];
                        const politeness = ['操作成功', '操作失败'];
                        const alert = [];
                        if (res?.data?.code === 0) {
                          setOpenExtend(false);
                          setSelected([]);
                          alert['politenessName'] = politeness[0];
                          alert['variants'] = variants[0];
                          fetchData();
                        } else {
                          alert['politenessName'] = politeness[1];
                          alert['variants'] = variants[1];
                        }
                        setAlerts(alert);
                        setAlertToggle('block');
                        setTimeout(() => {
                          setAlertToggle('none');
                          setAlerts([]);
                        }, 3000);
                      });
                    }}
                  >
                    确定
                  </Button>
                  <Button
                    color="primary"
                    onClick={() => {
                      setOpenExtend(false);
                      setSelected([]);
                    }}
                  >
                    关闭
                  </Button>
                </Modal.Footer>
              </Modal>
            </div>
            <div
              style={
                alertToggle && alertToggle === 'block'
                  ? {
                      display: 'block',
                      zIndex: '99',
                      position: 'fixed',
                      width: '30%',
                      bottom: '0',
                      right: '2% ',
                    }
                  : { display: 'none' }
              }
            >
              {
                <Alert
                  variant={alerts.variants}
                  margin="small"
                  renderCloseButtonLabel="Close"
                >
                  {alerts.politenessName}
                </Alert>
              }
            </div>
            <div
              style={
                rows && rows.length === 0
                  ? { display: 'block', marginTop: '35px' }
                  : { display: 'none' }
              }
            >
              <View
                as="div"
                maxHeight="100%"
                textAlign="center"
                margin="large"
                padding="large"
                position="relative"
              >
                <span
                  style={{
                    color: '#8FBFDA',
                    fontWeight: '700',
                    fontStyle: 'normal',
                    fontSize: '28px',
                  }}
                >
                  该课程尚未添加教参！
                </span>
                <img
                  src={imgURL}
                  alt=""
                  style={{ display: 'block', margin: '0 auto' }}
                />
              </View>
            </div>
            <div
              style={
                message && message !== ''
                  ? { display: 'block', marginTop: '35px' }
                  : { display: 'none' }
              }
            >
              <View
                as="div"
                maxHeight="100%"
                textAlign="center"
                margin="large"
                padding="large"
                position="relative"
              >
                <span
                  style={{
                    color: '#666666',
                    fontWeight: '700',
                    fontStyle: 'normal',
                    fontSize: '28px',
                  }}
                >
                  {message}
                </span>
              </View>
            </div>
          </>
        )}
      </div>

      <Recommend
        open={showRecommend}
        bsId={objInfo.bsId}
        ghId={ghId}
        selectedIdList={rowsIds}
        onCancel={() => setShowRecommend(false)}
        onSubmit={referenceList => {
          instance({
            method: 'post',
            url: `addKcAndReferenceBatch`,
            data: {
              kcId: objInfo.bsId,
              gh: ghId,
              referenceList,
            },
          }).then(res => {
            console.log(res);
            const variants = ['success', 'error'];
            const politeness = ['操作成功', '操作失败'];
            const alert = [];
            if (res?.data?.code === 0) {
              setShowRecommend(false);
              alert['politenessName'] = politeness[0];
              alert['variants'] = variants[0];
              fetchData();
            } else {
              alert['politenessName'] = politeness[1];
              alert['variants'] = variants[1];
            }
            setAlerts(alert);
            setAlertToggle('block');
            setTimeout(() => {
              setAlertToggle('none');
              setAlerts([]);
            }, 3000);
          });
        }}
      />
      
      {address && <EmailInfo />}
    </div>
  );
}
export default GuideBooks;
